
<template>
  <Breadcrumbs main="Event" title="Upload" />
  <div class="container-fluid">
    <div
      v-if="
        this.is_event_permission === 'Y' && this.eventDetails.uploadable === 'Y'
      "
    >
      <div class="col-sm-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div
                class="col-xl-12"
                style="
                  text-align: left;
                  background-color: lightgray;
                  border-radius: 1rem;
                "
              >
                <b>&nbsp;</b><br />
                <b>คำแนะนำการใช้งานระบบ</b>
                <p class="small-text">
                  <span style="font-size: medium; color: red">New!</span> 1.
                  ถ้าต้องการเปิดหลายแท็บ เพื่อเพิ่มความเร็ว
                  <span style="color: red; text-decoration: underline"
                    >ต้องเปิดในเบราว์เซอร์ต่างกัน</span
                  >
                  เช่น Google Chrome, Safari(Upload ได้ครั้งละไม่เกิน 2400 ใบ), Microsoft Edge, Frifox  <br />
                  <span style="font-size: medium; color: red">New!</span> 2.
                  ขณะกำลังอัปโหลดรูปเข้าระบบ สามารถย่อหน้าจอ เพื่อทำงานอื่นๆได้
                  ต่อได้โดยที่ระบบยังคง อัปโหลดให้ด้วยความเร็วปกติ<br />
                  3. Upload File JPEG (.jpg/.jpeg) เท่านั้น และ Upload File
                  ที่มีขนาดอย่างน้อย 3900px (Long Edge)<br />
                  4. ตรวจสอบให้แน่ใจว่าขนาดไฟล์ ไม่เกิน 4.5 MB
                  เพื่อประสิทธิภาพการอัปโหลดที่ดีที่สุด หากเกินแนะนำให้ Export
                  ก่อนอัปโหลดระบบ<br />
                  &nbsp;&nbsp;&nbsp;&nbsp; *ตั้งค่าการ Export: Quality: 70,
                  Resolution: 70, Image size: 4300px (Long Edge), Exp.<u
                    ><a
                      href="https://running.in.th/running-img/running-export-lr-setting.jpg"
                      target="_blank"
                      >ตัวอย่างการตั้งค่า Lightroom</a
                    ></u
                  ><br />

                  5. อัพโหลดภาพครั้งละประมาณ 1000-2000 ภาพ เพื่อความรวดเร็ว
                  (*สามารถอัปโหลด ครั้งละเยอะๆ 10,000+ แล้วไปนอนได้)<br />
                  6. ควรตั้งชื่อรูปไม่ให้ซ้ำกัน ระบบจะ Skip การอัปโหลด
                  ไฟล์ชื่อซ้ำ และ<font  style="color: red;">ไม่อนุญาติให้อัปโหลด รูปเดิมซ้ำ เข้าระบบ</font>
                  (ไม่แต่งรูปซ้ำแล้วอัปโหลดเข้ามาอีกครั้ง)<br />
                </p>

                <div class="row">
                  <div class="col-xl-9 col-sm-9">
                    <textarea
                      class="small-text"
                      rows="13"
                      v-model="this.eventDetails.post_caption"
                    >
                    </textarea>
                  </div>
                  <div
                    class="col-xl-3 col-sm-3 qr-code-container"
                    style="text-align: center"
                  >
                    <vue-qrcode
                      :value="this.qr_code"
                      :options="{
                        errorCorrectionLevel: 'high',
                        width: 180,
                        quality: 0.99,
                      }"
                    ></vue-qrcode
                    ><br />
                    <a
                      style="font-size: smaller"
                      target="_blank"
                      :href="
                        this.website_url + '/' + this.$route.params.q + '/qr'
                      "
                      ><u>ดาวน์โหลด QRCode ขนาดใหญ่</u></a
                    >
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-xl-4 col-sm-4" style="text-align: center">
                <p style="color: rgb(0, 0, 0)">
                  upload total: {{ this.total }} (<a
                    target="_blank"
                    :href="'/upload-images/' + this.eventDetails.event_key"
                    ><u>file list</u></a
                  >)
                </p>
              </div>
              <div class="col-xl-4 col-sm-4" style="text-align: center">
                <p style="color: rgb(255, 102, 0)">
                  wait for tagging: {{ this.processing }}
                </p>
              </div>
              <div class="col-xl-4 col-sm-4" style="text-align: center">
                <p style="color: green">tagged: {{ this.taged }}</p>
              </div>
            </div>
            <div
              class="card card-btn-upload"
              v-if="
                this.eventDetails.is_hybrid === 'Y' &&
                this.eventDetails.is_mhao_hybrid === 'N'
              "
            >
              <span
                >กิจกรรมนี้ เป็นรูปแบบการขายแบบไฮบริด มีการใช้งาน ระบบเครดิต<br />เครดิตคงเหลือ
                {{ this.credit_balance===0?'loading...':this.credit_balance }}</span
              >
              <a target="_blank" href="/credit-create"
                ><b><u>เติมเครดิต</u></b></a
              >
              <div class="row">
                <div class="col-sm-12">
                  <span style="color: red; font-size: small"
                    >*กรุณาอัปโหลดภาพให้เรียบร้อยก่อนเปิดขาย <u>{{ this.eventDetails.on_sale_start_txt }}</u> เพื่อรักษาสิทธิ์ในการขายภาพ ในรูปแบบแบบไฮบริด</span
                  >
                </div>
            </div>
            </div>
            <div
              class="card card-btn-upload"
              v-if="this.eventDetails.is_enable_image_adjustment === 'Y'"
            >
              <hr />
              <div class="col-sm-12">
                <span>เปิดใช้งานระบบแต่งภาพอัตโนมัติ: </span>&nbsp;&nbsp;
                <div class="form-check form-check-inline">
                  <input
                    class="form-check-input"
                    v-model="is_image_addjustment"
                    type="radio"
                    name="inlineRadioOptions"
                    id="inlineRadio1"
                    value="Y"
                  />
                  <label class="form-check-label" for="inlineRadio1">
                    เปิดใช้งาน
                  </label>
                </div>
                <div class="form-check form-check-inline">
                  <input
                    class="form-check-input"
                    v-model="is_image_addjustment"
                    type="radio"
                    name="inlineRadioOptions"
                    id="inlineRadio2"
                    value="N"
                  />
                  <label class="form-check-label" for="inlineRadio2">
                    ปิด
                  </label>
                </div>
              </div>
              <hr />
            </div>
          </div>
        </div>
      </div>

      <div class="card card-btn-upload">
        <div class="row" v-if="this.eventDetails.is_event_stage === 'Y'" style="padding-top: 10px;">
          <div class="col-sm-1 col-lg-1 col-xl-1"></div>
          <div class="col-sm-10 col-lg-10 col-xl-10">
            <div class="form-floating mb-3">
              <select 
                class="form-select"
                required
                id="floatingSelect"
                v-model="event_stages"
                aria-label="Floating label select example"
              >
                <option
                  v-for="(item, index) in this.eventDetails.stage"
                  :key="index"
                  :value="item.id"
                >
                  #{{ this.currentLanguage === "en" ? item.name_en : item.name }}
                </option>
              </select>
              <label for="floatingSelect"
                ># / Photo Locations / Activity / Stations</label
              >
            </div>
          </div>
          <div class="col-sm-1 col-lg-1 col-xl-1"></div>
        </div>

        <div class="col-sm-12">
          <div
            class="d-flex flex-column justify-content-center align-items-center text-center"
            style="white-space: normal; word-break: break-word"
          >
            <div style="font-size: 14px; color: gray">
              upload image to event
            </div>
            <b
              style="
                white-space: normal;
                word-break: break-word;
                margin-top: 4px;
              "
            >
              {{ this.eventDetails.title }} ({{ this.user.display_name }})
            </b>
          </div>
          <div class="card-body btn-showcase">
            <label
              class="btn btn-primary btn-sm"
              :class="{ disabled: upload_store.isUploading }"
              for="selectBtn"
            >
              <vue-feather type="upload-cloud" size="13"></vue-feather> Choose
              file to upload
            </label>
            <button
              class="btn btn-success btn-sm"
              :class="{ disabled: upload_store.isUploading }"
              @click.prevent="
                upload_store.uploadSelectedFiles(
                  this.eventDetails.event_key,
                  this.eventDetails.event_watermark_hori,
                  this.eventDetails.event_watermark_vertical,
                  this.user.user_id,
                  this.eventDetails.event_id,
                  this.eventDetails.server_upload_url_text,
                  this.eventDetails.server_upload_url_aws,
                  this.eventDetails.is_free_download,
                  this.eventDetails.is_add_watermark_for_free_download,
                  this.eventDetails.is_event_stage,
                  this.event_stages,
                  this.eventDetails.is_mhao,
                  this.eventDetails.is_hybrid,
                  this.eventDetails.is_mhao_hybrid,
                  this.credit_balance,
                  this.is_image_addjustment
                )
              "
              type="button"
              data-bs-toggle="tooltip"
              title="Upload"
            >
              {{
                upload_store.failed_count > 0 ? "Retry upload" : "Start upload"
              }}
            </button>
            <button
              class="btn btn-info btn-sm"
              :class="{ disabled: upload_store.isUploading }"
              type="button"
              data-bs-toggle="tooltip"
              title="Clear"
              @click.prevent="clear_upload"
            >
              <vue-feather type="refresh-cw" size="15"></vue-feather> Reset
            </button>
            <div class="row">
              <div class="col-xl-4 col-sm-4">
                <b
                  >upload queue (<span style="color: cornflowerblue">{{
                    upload_store.selectedFiles.length -
                    upload_store.success_count
                  }}</span
                  >)
                </b>
              </div>
              <div class="col-xl-4 col-sm-4">
                <b
                  >upload successful (<a
                    target="_blank"
                    :href="'/upload-images/' + this.eventDetails.event_key"
                    ><span style="color: green">{{
                      upload_store.success_count
                    }}</span></a
                  >)
                </b>
              </div>
              <div class="col-xl-4 col-sm-4">
                <b
                  >upload failed (<span style="color: red">{{
                    upload_store.failed_count
                  }}</span
                  >)
                </b>
              </div>
            </div>
          </div>
        </div>
      </div>
      <span
        v-show="uploadingFilesFailed.length"
        style="color: red; font-size: small"
      >
        {{ upload_store.errorMsg }}</span
      >
      <div style="height: 450px;">
      <div
        class="row"
        v-show="uploadingFilesFailed.length && !upload_store.isUploading"
      >
        <div class="col-sm-12">
          <div class="card">
            <div class="my-gallery card-body row gallery-with-description">
              <div
                class="col-xl-4 col-sm-4"
                v-for="(file, index) in uploadingFilesFailed"
                :key="index"
              >
                <span class="failed"
                  >{{ file.file.name }} [failed]
                  <div class="progress-bar-wrapper"></div>
                </span>
              </div>
            </div>
            &nbsp;
          </div>
        </div>
      </div>
      <div class="row" v-show="uploadingFiles.length">
        <div class="col-sm-12">
          <div class="card">
            <div class="my-gallery card-body row gallery-with-description">
              <div
                class="col-xl-12 col-sm-12"
                v-for="(file, index) in uploadingFiles"
                :key="index"
              >
                <span class="uploading"
                  >{{ file.file.name }} [uploading {{ file.percentage }}%]
                  <div class="progress-bar-wrapper">
                    <div
                      class="progress-bar-fill"
                      :style="{ width: file.percentage + '%' }"
                    ></div>
                  </div>
                </span>
              </div>
            </div>
            &nbsp;
          </div>
        </div>
      </div>
      </div>
    </div>
    <div v-if="this.eventDetails.uploadable === 'N'">
      <div class="row">
              <div
                class="col-xl-12"
                style="
                  text-align: left;
                  background-color: lightgray;
                  border-radius: 1rem;
                "
              >
                <b>&nbsp;</b><br />
                <b>คำแนะนำการใช้งานระบบ</b>
                <p class="small-text">
                  <span style="font-size: medium; color: red">New!</span> 1.
                  ถ้าต้องการเปิดหลายแท็บ เพื่อเพิ่มความเร็ว
                  <span style="color: red; text-decoration: underline"
                    >ต้องเปิดในเบราว์เซอร์ต่างกัน</span
                  >
                  เช่น Google Chrome, Safari(Upload ได้ครั้งละไม่เกิน 2400 ใบ), Microsoft Edge, Frifox <br />
                  <span style="font-size: medium; color: red">New!</span> 2.
                  ขณะกำลังอัปโหลดรูปเข้าระบบ สามารถย่อหน้าจอ เพื่อทำงานอื่นๆได้
                  ต่อได้โดยที่ระบบยังคง อัปโหลดให้ด้วยความเร็วปกติ<br />
                  3. Upload File JPEG (.jpg/.jpeg) เท่านั้น และ Upload File
                  ที่มีขนาดอย่างน้อย 3900px (Long Edge)<br />
                  4. ตรวจสอบให้แน่ใจว่าขนาดไฟล์ ไม่เกิน 4.5 MB
                  เพื่อประสิทธิภาพการอัปโหลดที่ดีที่สุด หากเกินแนะนำให้ Export
                  ก่อนอัปโหลดระบบ<br />
                  &nbsp;&nbsp;&nbsp;&nbsp; *ตั้งค่าการ Export: Quality: 70,
                  Resolution: 70, Image size: 4300px (Long Edge), Exp.<u
                    ><a
                      href="https://running.in.th/running-img/running-export-lr-setting.jpg"
                      target="_blank"
                      >ตัวอย่างการตั้งค่า Lightroom</a
                    ></u
                  ><br />

                  5. อัพโหลดภาพครั้งละประมาณ 1000-2000 ภาพ เพื่อความรวดเร็ว
                  (*สามารถอัปโหลด ครั้งละเยอะๆ 10,000+ แล้วไปนอนได้)<br />
                  6. ควรตั้งชื่อรูปไม่ให้ซ้ำกัน ระบบจะ Skip การอัปโหลด
                  ไฟล์ชื่อซ้ำ และ<font  style="color: red;">ไม่อนุญาติให้อัปโหลด รูปเดิมซ้ำ เข้าระบบ</font>
                  (ไม่แต่งรูปซ้ำแล้วอัปโหลดเข้ามาอีกครั้ง)<br />
                </p>

                <div class="row">
                  <div class="col-xl-9 col-sm-9">
                    <textarea
                      class="small-text"
                      rows="13"
                      v-model="this.eventDetails.post_caption"
                    >
                    </textarea>
                  </div>
                  <div
                    class="col-xl-3 col-sm-3 qr-code-container"
                    style="text-align: center"
                  >
                    <vue-qrcode
                      :value="this.qr_code"
                      :options="{
                        errorCorrectionLevel: 'high',
                        width: 180,
                        quality: 0.99,
                      }"
                    ></vue-qrcode
                    ><br />
                    <a
                      style="font-size: smaller"
                      target="_blank"
                      :href="
                        this.website_url + '/' + this.$route.params.q + '/qr'
                      "
                      ><u>ดาวน์โหลด QRCode ขนาดใหญ่</u></a
                    >
                  </div>
                </div>
              </div>
            </div>
            
      
    
      upload total: {{ this.total }} (<a
        target="_blank"
        :href="'/upload-images/' + this.eventDetails.event_key"
        ><u>file list</u></a
      >)

      <hr>
      <div class="d-flex justify-content-center" style="color: red">
        &nbsp;&nbsp;&nbsp;กิจกรรมนี้ปิดการอัปโหลดรูปภาพ หากต้องการอัปโหลดรูปภาพเพิ่มเติม กรุณาติดต่อหัวหน้าทีม หรือแอดมิน
      </div>
    </div>
    <div v-if="this.is_event_permission === 'CHECKING'">
      <div class="d-flex justify-content-center">authorized checking...</div>
    </div>
    <div v-if="this.is_event_permission === 'N'">
      <div class="d-flex justify-content-center">
        this page is not authorized
      </div>

      <div v-if="this.is_mhao !== 'Y' && this.loadding === 'N'">
        <div class="d-flex justify-content-center">event is not currect!</div>
      </div>
    </div>
  </div>

  <input
    id="selectBtn"
    type="file"
    multiple
    accept=".jpg, .jpeg"
    title="Upload file"
    @change="upload_store.onSelectFiles"
  />
</template>
  <script>
import { useUploadStore } from "./upload";
import axios from "axios";
import language from "@/components/header/language.vue";
export default {
  components: { language },
  setup() {
    const upload_store = useUploadStore();
    return { upload_store };
  },
  data() {
    return {
      eventDetails: {},
      selectedFiles: [],
      processing: 0,
      taged: 0,
      total: 0,
      loading: true,
      user: {},
      qr_code: process.env.VUE_APP_WEBSITE_URL + "/" + this.$route.params.q,
      is_event_permission: "CHECKING",
      event_stages: 0,
      credit_balance: 0,
      website_url: process.env.VUE_APP_WEBSITE_URL,
      is_image_addjustment: "N",
    };
  },
  computed: {
    uploadingFiles() {
      return this.upload_store.selectedFiles.filter(
        (file) => file.status === "uploading"
      );
    },
    uploadingFilesFailed() {
      return this.upload_store.selectedFiles.filter(
        (file) => file.status === "failed"
      );
    },
  },
  async mounted() {
    try {
      this.user = JSON.parse(localStorage.getItem("user"));
      let _is_event_permission = await this.event_permission();
      if (_is_event_permission === "Y") {
        let eventDetail = await this.getEventDetail(this.$route.params.q);
        await this.getTaged(eventDetail.event_id, this.user.user_id);
        if (
          this.eventDetails.is_hybrid === "Y" &&
          this.eventDetails.is_mhao_hybrid === "N"
        ) {
          await this.getCredit();
        }
      }
    } catch (error) {
      alert(
        "An error occurred. Please contact the administrator or try again.",
        error
      );
      location.reload();
    }
  },
  methods: {
    async getCredit(event_id, photographer_id) {
      const data = {
        event_id: event_id,
        photographer_id: photographer_id,
      };
      const headers = {
        Authorization: "Bearer " + localStorage.getItem("jwt"),
      };
      const res = await axios.post("/v1/utils/credit-balance", data, {
        headers,
      });
      if (res.data.status === "success") {
        this.credit_balance = res.data.body.credit_balance;
      } else {
        alert("[getCredit]พบข้อผิดพลาด!");
      }
    },
    async clear_upload() {
      document.getElementById("selectBtn").value = null;
      this.upload_store.clearFiles();
      this.event_stages = 0;
    },
    async event_permission() {
      try {
        let data = {
          event_key: this.$route.params.q,
        };
        const headers = {
          Authorization: "Bearer " + localStorage.getItem("jwt"),
        };
        const response = await axios.post("v1/order/event-permission", data, {
          headers,
        });
        if (response.data.status === "success") {
          this.is_event_permission = response.data.body.event_permission;
          return response.data.body.event_permission;
        } else {
          alert("Authentication Failed! ");
          return "N";
        }
      } catch (error) {
        alert("Authentication Failed! Please contact admin.");
        return "N";
      }
    },

    async getEventDetail(event_key) {
      const res = await axios.get("/v1/events/" + event_key);
      if (res.data.status === "success") {
        this.eventDetails = res.data;
        this.eventPackage = res.data.package;
        return res.data;
      } else {
        alert("[EventDetail]Please contact admin!");
        this.$router.push({ path: "/" });
      }
    },
    async getTaged(event_id, photographer_id) {
      const data = {
        event_id: event_id,
        photographer_id: photographer_id,
      };
      const res = await axios.post("/v1/events/taged", data);
      if (res.data.status === "success") {
        this.processing = res.data.processing;
        this.taged = res.data.taged;
        this.total = res.data.total;
      } else {
        alert("[Taged]Please contact admin!");
        this.$router.push({ path: "/" });
      }
    },
    cancel() {
      this.$router.push({ path: "/" });
    },
  },
};
</script>
<style scoped lang="scss">
#selectBtn {
  display: none;
}
.progress-bar-wrapper {
  height: 3px;
  background-color: #f0f0f0;
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: 2px;
}

.progress-bar-fill {
  height: 100%;
  background-color: #1890ff; /* สีแบบ ant.design */
  transition: width 0.1s ease;
}
.small-text {
  font-size: 13px;
  line-height: 1.2;
}
.card-btn-upload {
  text-align: center;
}
.card-file-list {
  text-align: center;
}

.upload-item {
  border: 1px solid rgb(197, 197, 197);
  border-radius: 0.5rem;
  float: left;
  padding: 1px;
  text-align: center;
}

.drop-container:hover {
  background: #979696ad;
}
.upload-item:hover {
  background: #e0e0e0ad;
  cursor: pointer;
  border: 1px dashed rgba(124, 2, 2, 0.616);
}

.buttons {
  display: flex;
  gap: 1rem;

  &.centered {
    justify-content: center;
  }
}

.button {
  cursor: pointer;

  color: white;
  background: #809af0;
  text-decoration: none;

  width: fit-content;
  padding: 0.5rem 1rem;
  border-radius: 2px;

  &:hover {
    background: #3f6cff;
  }

  &.disabled {
    cursor: default;
    background: lightgray;
    pointer-events: none;
  }
}

.button-danger {
  background: #f08080;

  &:hover {
    background: #f65959;
  }
}

.button-upload {
  background: #00d591;

  &:hover {
    background: #02b97f;
  }
}

.failed {
  color: red;
  font-size: x-small;
}

.success {
  color: green;
}

.uploading {
  color: #000000;
  font-size: x-small;
}

.failed-border {
  border-color: red;
}

textarea {
  width: 100%;
  background-color: #ffffffea;
  border-radius: 0.7rem;
}
.textwrapper {
  border: 1px solid #999999;
  margin: 5px 0;
  padding: 3px;
}
</style>